import { JWTAuth } from "../../../../lib/js-apiclient"
import { AdvancedApiClient } from "../../../../lib/js-apiclient/src/AdvancedApiClient";

export class TagApiClient extends AdvancedApiClient {

    static entityType = "WooCommerceTag"

    constructor(token, channelId) {
        super();

        this.setEntityType(TagApiClient.entityType)
            .setRoute("/api/v1/channel/{id}/woocommerce/tag")
            .setRouteParam("id", channelId);
        
        if(token !== undefined && token !== null) {
            this.appendAuthSchema(new JWTAuth(token))
        }
    }

}